import React from 'react'
import { connect } from 'react-redux'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import { currentUser } from '../../redux/selectors/user'
import classNames from 'classnames'
import './PlaylistRow.scss'

const PlaylistRow = ({ playlist, ...props }) => {
  const getPlaylistImage = () => {
    return (
      <div className='images'>
        <img src={playlist.imageUrl()} />
      </div>
    )
  }

  let playlistImage
  if (props.includeImage) {
    playlistImage = (
      <div className='top-entry-images single-image'>{getPlaylistImage()}</div>
    )
  }

  let playlistAuthor
  if (props.currentUser.username !== playlist.author.username) {
    playlistAuthor = (
      <span className='PlaylistRow__author'>
        By {playlist.author.firstName} {playlist.author.lastName}{' '}
      </span>
    )
  }

  const rowItemClass = classNames('PlaylistRow', {
    'PlaylistRow--active': props.active,
    'PlaylistRow--marked': props.marked
  })

  return (
    <li
      className={rowItemClass}
      id={`playlist_${playlist.id}`}
      data-id={playlist.id}
      onClick={() => {
        props.onSelect(playlist)
      }}
    >
      {playlistImage}
      <div className='PlaylistRow__details'>
        <div className='PlaylistRow__name'>{playlist.title}</div>
        <span className='PlaylistRow__meta'>
          {playlistAuthor}
          <span className='num-classes'>
            {`${playlist.entryCount} ${pluralize(
              'Class',
              playlist.entryCount
            )}`}
          </span>
        </span>
      </div>
      <i className='fa fa-angle-right' />
    </li>
  )
}

PlaylistRow.defaultProps = {
  includeImage: true
}

PlaylistRow.propTypes = {
  active: PropTypes.bool,
  marked: PropTypes.bool,
  includeImage: PropTypes.bool,
  playlist: PropTypes.object,
  currentUser: PropTypes.object,
  onSelect: PropTypes.func
}

const mapStateToProps = state => {
  return {
    currentUser: currentUser(state)
  }
}

export default connect(mapStateToProps)(PlaylistRow)
